import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getStockList({
    cursor = '',
    limit = '',
    product_id = '',
    q = '',
    warehouse_id = '',
  } = {}) {
    const params = {
      cursor,
      limit,
      product_id,
      q,
      warehouse_id,
    };
    return api.get('/rent_stocks', { params: omitBy(params, isNil) });
  },
  getStockReport() {
    return api.get('/rent_stocks/stock_reports');
  },
  getProductStock(productId) {
    return api.get(`/rent_stocks/products/${productId}`);
  },
  updateStock(id, payload) {
    return api.put(`/rent_stocks/${id}`, payload);
  },
  bulkUpdateStock(payload) {
    return api.post('/rent_stocks/bulk_update', payload);
  },
  createStock(payload) {
    return api.post('/rent_stocks', payload);
  },
};
